module.exports = __webpack_public_path__ + "static/media/remove_search.53fa9080.svg";